import './FeatureSpotlight.scss';

import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Typography } from '@material-ui/core';
import { Button } from '@fifth-gear-tech/common-components/dist/components';
import { ButtonType } from '@fifth-gear-tech/common-components/dist/utils/StyledTheme';
import Logger from '@KrashidBuilt/common/utils/logger';

import { SpotlightContext } from '../../ctx';
import { CACHE_KEY } from '../../constants';

const logger = new Logger('FeatureSpotlight');

const FeatureSpotlight = ({ feature, canRender = () => true, step, header, body, styles, onDismiss, tail = true, overlay = true, tilt = true }) => {
    const { feat, setFeature, s, setStep, hydrateSteps, nextStep } = useContext(SpotlightContext);
    const [active, setActive] = useState(false);

    logger.extra({ inContext: { feat, s }, inProps: { feature, step }, active });

    useEffect(() => {
        hydrateSteps(feature, step); // tell context to hydrate steps provided from this spotlight
    }, []);

    useEffect(() => {
        const completed = JSON.parse(localStorage.getItem(CACHE_KEY.SPOTLIGHT_COMPLETED)) || [];
        if (!completed.includes(feature) && canRender(feature)) {
            // tell spotlight to display this feature
            if (feat === null && s === null) {
                setFeature(feature);
                setStep(0); // first step
                return;
            }
        }
        // active spotlight if feature and step are the same
        return setActive(feature == feat && s == step);
    }, [feat, s]);

    return active ?
        <div className='FeatureSpotlight'>
            {overlay && <div className='DarkOverlay' />}
            <div className={`SpotlightArea${tilt ? ' Tilt' : ''}`} style={styles}>
                <div className={`SpotlightBubble${tail ? ' Tail' : ''}`}>
                    <Typography variant='h5'>{header}</Typography>
                    <hr style={{ border: '1px solid black', width: '100%' }} />
                    <Typography variant='body1' className='SpotlightBody'>{body}</Typography>
                    <Button className={'SpotlightButton'} type={ButtonType.Save} colorTheme={'success'} label='' onClick={() => {
                        nextStep(feature, step);
                        { onDismiss && onDismiss(); }
                    }}
                    />
                </div>
            </div>
        </div> : null;
};

FeatureSpotlight.propTypes = {
    tail: PropTypes.bool,
    tilt: PropTypes.bool,
    feature: PropTypes.string,
    canRender: PropTypes.func,
    step: PropTypes.number,
    header: PropTypes.any,
    body: PropTypes.any,
    styles: PropTypes.object,
    onDismiss: PropTypes.func,
    overlay: PropTypes.bool
};

export default FeatureSpotlight;